import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it paper or digital?',
  a: 'It is a 100% digital product (High-Resolution PDF) optimized for Laptop, Tablet, Smartphone, and iPad. You receive instant access by email the moment your purchase is confirmed.'
}, {
  q: 'Is it suitable for beginner coaches?',
  a: 'Yes. The system is designed for both new and experienced running coaches. The Running Foundations™ module covers all the basics you need to start coaching safely and effectively.'
}, {
  q: 'Can I use it with individual athletes and groups?',
  a: 'Absolutely. The programs and templates work for both one-on-one coaching and group training environments, including running clubs and track teams.'
}, {
  q: 'Does it include race preparation programs?',
  a: 'Yes. The system includes 5K, 10K, Half Marathon, Marathon, and endurance-focused frameworks, plus a dedicated Race Day Success System™ bonus.'
}, {
  q: 'How quickly will I see results?',
  a: 'Most coaches report saving several hours of planning time during their first week of use. Your athletes will benefit immediately from the structured, professional programming.'
}, {
  q: 'Do I need special software to use this?',
  a: 'No. The entire system is delivered in universal PDF format. You can read it on any device, print the assessment forms, and use the templates immediately without buying additional software.'
}, {
  q: 'Are the workouts adaptable for different paces?',
  a: 'Yes. The Session Builder System™ teaches you how to scale workouts based on individual athlete fitness levels, using time-based intervals, RPE (Rate of Perceived Exertion), and pace zones.'
}, {
  q: 'Is this a monthly subscription?',
  a: 'No. It is a one-time payment of $27 USD. You get lifetime access to the complete 6-in-1 system and all 5 premium bonuses with no recurring fees.'
}, {
  q: 'What if I coach trail runners?',
  a: 'The core principles apply to all runners, and we specifically included the Trail Running Coach Toolkit™ (Bonus 3) to address the unique demands of off-road endurance athletes.'
}, {
  q: 'What is the refund policy?',
  a: 'You are protected by our 7-Day Total Guarantee. If you are not completely satisfied, simply email us within 7 days of purchase for a full, no-questions-asked refund.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 px-4 sm:px-6 bg-white" data-id="element-35">
      <div className="text-center mb-10" data-id="element-36">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-2 uppercase leading-tight" data-id="element-37">
          FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>

      <div className="flex flex-col gap-3 max-w-3xl mx-auto" data-id="element-38">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-paper border border-gray-200 rounded-lg overflow-hidden shadow-sm transition-colors hover:border-brand-teal/50" data-id="element-39">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center gap-4 focus:outline-none" aria-expanded={openIndex === i} data-id="element-40">
              <span className="font-bold text-brand-navy text-sm sm:text-base leading-tight" data-id="element-41">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-brand-teal transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-42" />
            </button>

            {openIndex === i && <div className="px-5 pb-5 text-brand-ink/80 text-sm leading-relaxed border-t border-gray-200 pt-4" data-id="element-43">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}